var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLastArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490.8 490.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.144,490.68c-5.891,0.011-10.675-4.757-10.686-10.648c-0.005-2.84,1.123-5.565,3.134-7.571l227.136-227.115 L216.592,18.232c-4.093-4.237-3.975-10.99,0.262-15.083c4.134-3.992,10.687-3.992,14.82,0l234.667,234.667 c4.164,4.165,4.164,10.917,0,15.083L231.675,487.565C229.676,489.56,226.968,490.68,224.144,490.68z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.144,490.68c-5.891,0.011-10.675-4.757-10.686-10.648c-0.005-2.84,1.123-5.565,3.134-7.571l227.136-227.115 L24.592,18.232c-4.171-4.171-4.171-10.933,0-15.104s10.933-4.171,15.104,0l234.667,234.667c4.164,4.165,4.164,10.917,0,15.083 L39.696,487.544C37.695,489.551,34.978,490.68,32.144,490.68z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastArrow);
export default __webpack_public_path__ + "static/media/last_arrow.fa1605ff.svg";
export { ForwardRef as ReactComponent };